import local from '@/local/ar';
import { activitiesStatusEnum, attorneyTypeEnum, booleanEnum, creditorClassificationsEnum, paymentStatusEnum } from '../../helpers/enum';
import { getLookupFromLocalStorage } from '../../helpers/utils';

export default {
  mainRequestCategories: getLookupFromLocalStorage('mainRequestCategories'),
  requestOwnerTypes: getLookupFromLocalStorage('requestOwnerTypes'),
  allRequestOwnerTypes: getLookupFromLocalStorage('allRequestOwnerTypes'),
  legalCapacities: getLookupFromLocalStorage('legalCapacities'),
  commercialCourts: getLookupFromLocalStorage('commercialCourts'),
  procedureTypes: getLookupFromLocalStorage('procedureTypes'),
  mainRequestStatuses: getLookupFromLocalStorage('mainRequestStatuses'),
  identityTypes: getLookupFromLocalStorage('identityTypes'),
  partyTypes: getLookupFromLocalStorage('partyTypes'),
  firmTypes: getLookupFromLocalStorage('firmTypes'),
  organizedEntityTypes: getLookupFromLocalStorage('organizedEntityTypes'),
  debtorClassifications: getLookupFromLocalStorage('debtorClassifications'),
  assetTypes: getLookupFromLocalStorage('assetTypes'),
  realEstateTypes: getLookupFromLocalStorage('realEstateTypes'),
  partyTypeDebtorClassifications: getLookupFromLocalStorage('partyTypeDebtorClassifications', true),
  activitiesStatus: [
    {
      id: activitiesStatusEnum.inActive,
      name: local.bankruptcy.activitiesForm.inActive,
    },
    {
      id: activitiesStatusEnum.active,
      name: local.bankruptcy.activitiesForm.active,
    },
  ],
  attorneyTypes: [
    {
      id: attorneyTypeEnum.internal,
      name: local.bankruptcy.attorneyTypes.internal,
    },
    {
      id: attorneyTypeEnum.external,
      name: local.bankruptcy.attorneyTypes.external,
      },
    ],

  genders: [
    {
      id: 1,
      name: local.bankruptcy.genders.male,
    },
    {
      id: 2,
      name: local.bankruptcy.genders.female,
    },
  ],

  partyTypesBankRuptcyFile: [
    {
      id: 1,
      name: local.bankruptcy.bankruptcyFile.partyTypesBankRuptcyFile.person,
    },
    {
      id: 2,
      name: local.bankruptcy.bankruptcyFile.partyTypesBankRuptcyFile.firm,
    },
    {
      id: 3,
      name: local.bankruptcy.bankruptcyFile.partyTypesBankRuptcyFile.organization,
    },
    {
      id: 4,
      name: local.bankruptcy.bankruptcyFile.partyTypesBankRuptcyFile.government,
    },
    {
      id: 9,
      name: local.bankruptcy.bankruptcyFile.partyTypesBankRuptcyFile.foreignOrganization
    },
  ],

  yesNoOptions: [
    {
      id: booleanEnum.yes,
      name: local.common.yes,
    },
    {
      id: booleanEnum.no,
      name: local.common.no,
    },
  ],
  paymentStatuses: [
    {
      id: paymentStatusEnum.notPaid,
      name: local.bankruptcy.paymentStatus.notPaid,
    },
    {
      id: paymentStatusEnum.partiallyPaid,
      name: local.bankruptcy.paymentStatus.partiallyPaid,
    },
  ],
  creditorClassifications: [
    {
      id: creditorClassificationsEnum.funding,
      name: local.bankruptcy.creditorClassifications.funding,
    },
    {
      id: creditorClassificationsEnum.governmental,
      name: local.bankruptcy.creditorClassifications.governmental,
    },
    {
      id: creditorClassificationsEnum.other,
      name: local.bankruptcy.creditorClassifications.other,
    },
  ],
  globalAttachmentTypes: getLookupFromLocalStorage('globalAttachmentTypes'),
  currencies: getLookupFromLocalStorage('currencies'),
  countries: getLookupFromLocalStorage('countries'),
  subRegions: getLookupFromLocalStorage('subRegions', true),
  subCities: getLookupFromLocalStorage('subCities', true),
  countryCities: getLookupFromLocalStorage('countryCities', true),
  subRequestTypes: getLookupFromLocalStorage('subRequestTypes'),
  subRequestStatuses: getLookupFromLocalStorage('subRequestStatuses'),
  stakeholderTypes: getLookupFromLocalStorage('stakeholderTypes'),
  organizations: getLookupFromLocalStorage('organizations'),
};
